export default __webpack_public_path__ + "static/media/activity-watchlist-icon.77501c26.svg";